module.exports = __webpack_public_path__ + "static/media/Existentialism.4e72920f.png";